import { render } from "./TestimonialFooter.vue?vue&type=template&id=2efcaf37"
import script from "./TestimonialFooter.vue?vue&type=script&lang=js"
export * from "./TestimonialFooter.vue?vue&type=script&lang=js"

import "./TestimonialFooter.vue?vue&type=style&index=0&id=2efcaf37&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__